import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.17773 1.78125V7.40625H13.8027C14.2598 7.40625 14.6465 7.79297 14.6465 8.25C14.6465 8.74219 14.2598 9.09375 13.8027 9.09375H8.17773V14.7188C8.17773 15.2109 7.79102 15.5625 7.33398 15.5625C6.8418 15.5625 6.49023 15.2109 6.49023 14.7188V9.09375H0.865234C0.373047 9.09375 0.0214844 8.74219 0.0214844 8.25C0.0214844 7.79297 0.373047 7.40625 0.865234 7.40625H6.49023V1.78125C6.49023 1.32422 6.8418 0.9375 7.33398 0.9375C7.79102 0.9375 8.17773 1.32422 8.17773 1.78125Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
